import { fromJS, Seq } from 'immutable';
import * as types from '../constants';
//import { hasTabellone } from '../common/rcs_gaz_mc_core_FE';

const initialState = fromJS({
  calendar: {
    games: [],
    numberDays: null,
    currentDay: null,
  },
  cupCalendar: {
    games: [],
    numberDays: null,
    currentDay: null,
  },
  cupTabbar: [],
  motorSportCalendar: [],
  tennisCalendar: [],
  cycleCalendar: {},
  tennisTabbar: [],
  currentTennisPhase: '',
  hasHighlights: true,
  nbaCurrentDay: null,
  basketCurrent: {
    currentPhase: null,
    currentSubPhase: null,
  },
});

function currentDate() {
  const dateJs = new Date();
  const month = (`0${Number(dateJs.getMonth().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })) + 1}`).slice(-2);
  const day = (`0${dateJs.getDate().toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}`).slice(-2);
  const year = dateJs.getFullYear();
  return `${year}-${month}-${day}`;
}

function setTennisTabbar(data) {
  let tabbar = [];
  if (data && data.competitionRounds) {
    tabbar = data.competitionRounds.map(round => round.name);
  }
  return tabbar;
}


function getCurrentPhase(data) {
  let roundCounter = 0;
  for (const round of data.competitionRounds) {
    for (const currentMatch of round.match) {
      if (currentMatch[currentDate()]) {
        return data.competitionRounds[roundCounter].name;
      }
    }
    roundCounter += 1;
  }
  return data.competitionRounds && data.competitionRounds[0] && data.competitionRounds[0].name ? data.competitionRounds[0].name : '';
}

function buildVolleyData(data) {
  let keys = [];
  let gameNumber = 1;
  let addGameNumber = true;

  data.games.forEach((x) => {
    if (x.firstLeg && x.firstLeg[0] && x.firstLeg[0].matches) {
      x.firstLeg[0].matches.forEach((match) => {
        let teamId = false;
        if (keys.indexOf(match.teamAId) > -1) {
          teamId = match.teamAId;
        } else if (keys.indexOf(match.teamBId) > -1) {
          teamId = match.teamBId;
        } else {
          keys.push(match.teamAId);
        }
        if (teamId) {
          gameNumber += 1;
          keys = [];
          keys.push(teamId);
          addGameNumber = true;
        }
      });
      if (addGameNumber) {
        x.firstLeg[0].gameNumber = gameNumber;
        addGameNumber = false;
      }
    }
  });
  return data;
}

function buildBasketData(data, phase) {
  if (!['playoffs', 'nbacup', 'extraplayoffs', 'groups'].includes(phase.toLowerCase())) {
    return data.games;
  }
  const keys = {};

  const gameGroups = {};
  const gameGroupsNumb = {};

  data.games.forEach((x) => {
    if (x.firstLeg && x.firstLeg[0] && x.firstLeg[0].matches) {
      const { date } = x.firstLeg[0];
      x.firstLeg[0].matches.forEach((match) => {
        let teamId = false;
        let gameNumber = 0;
        if (match.teamHome.teamId && match.teamAway.teamId) {
          const teamHomeId = match.teamHome.teamId;
          const teamAwayId = match.teamAway.teamId;
          if (Object.keys(keys).indexOf(teamHomeId) > -1) {
            teamId = teamHomeId;
          } else if (Object.keys(keys).indexOf(teamAwayId) > -1) {
            teamId = teamAwayId;
          } else {
            teamId = teamHomeId;
            keys[teamId] = 0;
          }
          if (!gameGroupsNumb[teamHomeId]) {
            gameGroupsNumb[teamHomeId] = 0;
          }
          if (!gameGroupsNumb[teamAwayId]) {
            gameGroupsNumb[teamAwayId] = 0;
          }
          gameGroupsNumb[teamHomeId] += 1;
          gameGroupsNumb[teamAwayId] += 1;
          gameNumber = Math.max(gameGroupsNumb[teamHomeId], gameGroupsNumb[teamAwayId]);
        }

        let gameGroup = {};
        if (typeof gameGroups[gameNumber] === 'undefined') {
          gameGroups[gameNumber] = {};
        }
        if (typeof gameGroups[gameNumber][date] === 'undefined') {
          gameGroups[gameNumber][date] = {};
          gameGroup.matches = phase.toLowerCase() === 'groups' ? {} : [];
          gameGroup.date = date;
          gameGroup.extraPlayoffs = data.extraPlayoffs;
        } else {
          gameGroup = gameGroups[gameNumber][date];
        }
        if (phase.toLowerCase() === 'groups') {
          const groupName = `Pool ${match.groupName}`;
          if (!gameGroup.matches[groupName]) {
            gameGroup.matches[groupName] = [];
          }
          gameGroup.matches[groupName].push(match);
        } else {
          gameGroup.matches.push(match);
        }
        gameGroups[gameNumber][date] = gameGroup;
      });
    }
  });
  const games = [];
  Object.keys(gameGroups).forEach((key) => {
    const gameGroup = {};
    gameGroup.gameNumber = key;
    gameGroup.days = [];
    Object.keys(gameGroups[key]).forEach((k) => {
      gameGroup.days.push(gameGroups[key][k]);
    });
    games.push(gameGroup);
  });
  return games;
}

function fromJSGreedy(js) {
  return typeof js !== 'object' || js === null ? js :
    Array.isArray(js) ?
      Seq(js).map(fromJSGreedy).toList() :
      Seq(js).map(fromJSGreedy).toOrderedMap();
}

export default function calendarReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_DAY_CALENDAR_SUCCESS:
      return state.setIn(['calendar', 'games'], (fromJS(action.data.games)))
        .set('calendar', fromJS(action.data))
        .setIn(['calendar', 'currentDay'], fromJS(action.currentDay));
    case types.GET_CUP_CALENDAR_SUCCESS:
      return state.set('cupCalendar', fromJS(action.data))
        .setIn(['cupTabbar', 'lastPhase', 'label'], fromJS(action.data.lastPhase))
        .setIn(['cupTabbar', 'lastSubPhase'], fromJS(action.data.lastSubPhase))
        .setIn(['cupCalendar', 'currentDay'], fromJS(action.data.currentDay))
        .setIn(['cupCalendar', 'numberDays'], fromJS(action.data.numberDays))
        .setIn(['calendar', 'currentDay'], fromJS(action.data.currentDay))
        .setIn(['calendar', 'numberDays'], fromJS(action.data.numberDays));
    case types.GET_VOLLEY_CALENDAR_SUCCESS:
      return state.set('cupCalendar', fromJS(buildVolleyData(action.data)));
    case types.GET_CUP_DAY_CALENDAR_SUCCESS:
      return state.setIn(['cupCalendar', 'games'], fromJS(action.data.games))
        .setIn(['cupCalendar', 'lastPhase'], fromJS(action.data.lastPhase))
        .setIn(['cupTabbar', 'lastPhase', 'label'], fromJS(action.data.lastPhase))
        .setIn(['cupTabbar', 'lastSubPhase'], fromJS(action.data.lastSubPhase))
        .setIn(['cupCalendar', 'lastSubPhase'], fromJS(action.data.lastSubPhase));
    case types.GET_VOLLEY_DAY_CALENDAR_SUCCESS:
      return state.set('cupCalendar', fromJS(action.data))
        .setIn(['cupTabbar', 'lastPhase', 'label'], fromJS(action.data.lastPhase))
        .setIn(['cupTabbar', 'lastSubPhase'], fromJS(action.data.lastSubPhase));
    case types.GET_QUERY_PARAM_CALENDAR_SUCCESS:
      return state.setIn(['calendar', 'games'], fromJS(action.data.games))
        .setIn(['calendar', 'numberDays'], fromJS(action.data.numberDays))
        .setIn(['calendar', 'currentDay'], fromJS(action.currentDay));
    case types.GET_CALENDAR_SUCCESS:
    case types.GET_RUGBY_CALENDAR_SUCCESS:
      return state.set('calendar', fromJS(action.data));
    case types.TOGGLE_HIGHLIGHTS:
      return state.set('hasHighlights', !action.checked);
    case types.GET_CUP_TABBAR_SUCCESS:
      return state.set('cupTabbar', fromJSGreedy(action.data));
    case types.GET_VOLLEY_TABBAR_SUCCESS:
    case types.GET_RUGBY_TABBAR_SUCCESS:
    case types.GET_BASKET_TABBAR_SUCCESS:
      return state.set('cupTabbar', fromJSGreedy(action.data));
    case types.GET_MOTORSPORT_CALENDAR_SUCCESS:
      return state.set('motorSportCalendar', fromJS(action.data.contents[0][action.data.tableRowsKey]));
    case types.GET_CYCLE_CALENDAR_SUCCESS:
      return state.set('cycleCalendar', fromJS(action.data));
    case types.GET_TENNIS_CALENDAR_SUCCESS: {
      return state.set('tennisCalendar', fromJS(action.data))
        .set('tennisTabbar', setTennisTabbar(action.data))
        .set('currentTennisPhase', action.data.phase || fromJS(getCurrentPhase(action.data)));
    }
    case types.SET_TENNIS_PHASE:
      return state.set('currentTennisPhase', fromJS(action.phase));
    case types.GET_NBA_CALENDAR_SUCCESS:
      return state.set('nbaCurrentDay', action.currentDay)
        .setIn(['basketCurrent', 'currentPhase'], action.phase)
        .setIn(['basketCurrent', 'currentSubPhase'], action.subPhase)
        .setIn(['calendar', 'games'], fromJS(buildBasketData(action.data, action.phase)));
    case types.GET_BASKET_CALENDAR_SUCCESS:
      return state.setIn(['basketCurrent', 'currentPhase'], action.phase)
        .setIn(['basketCurrent', 'currentSubPhase'], action.subPhase)
        .setIn(['calendar', 'numberDays'], fromJS(action.data.numberDays))
        .setIn(['calendar', 'currentDay'], fromJS(action.currentDay))
        .setIn(['calendar', 'games'], fromJS(buildBasketData(action.data, action.phase)));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/calendar.js